import React,  {Component} from "react";
import "./titleComponent.css";

class TitleComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
          class: "main-text-title",
          type: 'title',
          bold: '',
          bolder: ''
        };
      }
    
    componentDidMount() {
    this.setState({
        class: this.props.black
        ? `${this.state.class} black`
        : this.state.class,
        type: this.props.subtitle ? 'subtitle' : 'title',
        bold: this.props.bold ? 'bold' : '',
        bolder: this.props.bolder ? 'bolder' : ''
    });
    }

    render() {
        return (
            <p className={`
                ${this.state.class} 
                ${this.state.type} 
                ${this.state.bold} 
                ${this.state.bolder} 
                ${this.props.className ?? ''}`}>
                {this.props.children}
            </p>
        );
    }
}

export default TitleComponent;